import { useState, useEffect } from 'react';

const useImageDimensionsParser = (url) => {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    let image = new Image();
    image.onload = function () {
      setWidth(image.naturalWidth);
      setHeight(image.naturalHeight);
    };
    image.src = url;
  }, [url]);

  return { width, height };
};

export { useImageDimensionsParser };
